import { Typography } from '@mui/material';
import React from 'react';
import type { PushPanelExtrasProps } from '../../types';

const ZapierPushPanelExtras: React.FC<PushPanelExtrasProps> = ({
  isDark,
}) => (
  <Typography variant="caption" sx={{ color: isDark ? '#98A2B3' : '#667085' }}>
    Use Test Push to send a sample payload to your Zapier Catch Hook and verify the connection.
  </Typography>
);

export default ZapierPushPanelExtras;
